module.exports = __webpack_public_path__ + "img/adviser-enrolment-image1.685e59ff.png";